import { gql } from '@apollo/client';

const emailLogData = gql`
  fragment emailLogData on EmailLog {
    id
    status
    createdAt
    updatedAt
    emailTemplate {
      id
      emailId
      subject
    }
    to {
      id
      type
      level
      role {
        id
        name
      }
      faculty {
        id
        abbreviation
      }
      department {
        id
        abbreviation
      }
      user {
        id
        email
        netId
      }
    }
    cc {
      id
      type
      level
      role {
        id
        name
      }
      faculty {
        id
        abbreviation
      }
      department {
        id
        abbreviation
      }
      user {
        id
        netId
        email
      }
    }
  }
`;

export const GET_EMAIL_LOGS = gql`
  ${emailLogData}
  query GET_EMAIL_LOGS(
    $pageSize: Int
    $current: Int
    $sort: EmailLogSort
    $emailId: ID
  ) {
    emailLogConnection(
      pageSize: $pageSize
      current: $current
      sort: $sort
      emailId: $emailId
    ) {
      totalCount
      nodes {
        ...emailLogData
      }
    }
  }
`;

export const GET_EMAIL_LOG_DETAIL = gql`
  ${emailLogData}
  query GET_EMAIL_LOG_DETAIL($ids: [ID!]) {
    emailLogs(ids: $ids) {
      ...emailLogData
      project {
        id
        title
      }
      projectApplication {
        id
        title
      }
      errorMessage
      emailBody
      emailTemplate {
        senderEmail
        senderName
      }
    }
  }
`;
